export default {
    control: {
      backgroundColor: '#fff',
  
      fontSize: 13,
      fontWeight: 'normal',
    },
  
    highlighter: {
      overflow: 'hidden',
    },
  
    input: {
      margin: 0,
      fontSize: 13
      // border: 'none'
    },
  
    '&singleLine': {
      control: {
        display: 'inline-block',
  
        width: 130,
      },
  
      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },
  
      input: {
        padding: 1,
  
        // border: '2px inset',
      },
    },
  
    '&multiLine': {
      control: {
        // fontFamily: 'monospace',

          border: 0,
        // border: '1px solid silver',
      },
  
      highlighter: {
        padding: 9,
      },
  
      input: {
        padding: 9,
        minHeight: '1rem',
        outline: 0,
        border: 0,
      },
    },
  
    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 10,
      },
  
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid rgba(0,0,0,0.15)',
  
        '&focused': {
            padding: '5px 15px',
          backgroundColor: "rgb(234,97,28)",
        },
      },
    },
  }
  